import { type LoaderFunctionArgs } from 'react-router';

import { secondOpinionReservationStore } from '../../hooks/reservation/second-opinion.ts';

export { default } from '../booking/request-status.tsx';

export function secondOpinionRequestStatusLoader({
  request,
}: LoaderFunctionArgs) {
  const url = new URL(request.url);
  if (
    url.searchParams.get('ok') === '1' &&
    secondOpinionReservationStore.read() !== null
  ) {
    secondOpinionReservationStore.write(null);
  }
  return { retryPath: '/second-opinion/payments' };
}
